module.exports = __webpack_public_path__ + "static/host_bg.ebf2e619.png";